import React from "react";
import { Language } from "@mui/icons-material";
import { useLocale } from "@/middleware";
import { Link, useLocation } from "react-router-dom";
import { routes } from "@/consts";
import { LANG } from "@/types";
import { Typography, Box, useTheme, alpha } from "@mui/material";

interface LanguageSelectorProps {
  show?: boolean;
  className?: string;
  classNM?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ show = true,className }) => {
  const { locale } = useLocale();
  const theme = useTheme();

  const location = useLocation();
  const getNextLocale = () => {
    return locale === LANG.EN ? LANG.AR : LANG.EN;
  };

  // Handle language change
  const handleLanguageSwap = () => {
    const pathName = location.pathname;
    const searchParams = location.search;
    if (!pathName) return routes.home;
    const segments = pathName.split("/");
    segments[1] = getNextLocale();
    return segments.join("/") + searchParams;
  };

  return (
    <Box
      component={Link}
      to={handleLanguageSwap()}
      className={className}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        color: "text.primary",
        textDecoration: "none",
        fontWeight: 600,
        fontSize: "0.875rem",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          color: theme.palette.primary.main,
        },
      }}
    >
      <Language
        sx={{
          fontSize: "1.25rem",
          color: "inherit",
        }}
      />
      {show && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "inherit",
            fontSize: "0.875rem",
          }}
        >
          {locale === LANG.AR ? "ع" : locale.toUpperCase()}
        </Typography>
      )}
    </Box>
  );
};

export default LanguageSelector;
